export default {
  MINERAL: 1567,
  SILICONE: 1187,
  VEGETAL: 687,
};
